import { useKeySequence } from '@/hooks/useKeySequence'
import { createContext, useContext, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'

type DarkThemeContextType = {
  isDarkTheme: boolean
  toggleDarkMode: () => void
  showABButtons: boolean
  processInput: (value: string) => void
  isUnlocked: boolean
}

const DarkThemeContext = createContext<DarkThemeContextType>({
  isDarkTheme: false,
  toggleDarkMode: () => {},
  showABButtons: false,
  processInput: () => {},
  isUnlocked: false,
})

export function DarkThemeProvider({ children }: React.PropsWithChildren) {
  const [isDarkMode, setIsDarkMode] = useLocalStorage('dark-mode', false)
  const [isUnlocked, setIsUnlocked] = useLocalStorage('unlocked-dark-theme', false)
  const [showABButtons, setShowABButtons] = useState(false)

  useKeySequence(
    [
      'arrowUp',
      'arrowUp',
      'arrowDown',
      'arrowDown',
      'arrowLeft',
      'arrowRight',
      'arrowLeft',
      'arrowRight',
    ],
    () => setShowABButtons(true),
    {
      enabled: !isUnlocked,
    },
  )
  const { processInput } = useKeySequence(
    ['buttonB', 'buttonA'],
    () => {
      setIsUnlocked(true)
      setShowABButtons(false)
      setIsDarkMode(true)
    },
    {
      enabled: !isUnlocked,
    },
  )

  return (
    <DarkThemeContext.Provider
      value={{
        isDarkTheme: isUnlocked && isDarkMode,
        toggleDarkMode: () => setIsDarkMode(!isDarkMode),
        showABButtons,
        processInput,
        isUnlocked: isUnlocked,
      }}
    >
      {children}
    </DarkThemeContext.Provider>
  )
}

export function useDarkTheme() {
  return useContext(DarkThemeContext)
}
